import React, { useEffect, useRef, useState } from "react"
import { useHistory } from "react-router"
import Button from "../../../../components/Button"
import Toast from "../../../../components/Toast"
import ToggleSwitch from "../../../../components/ToggleSwitch"
import { getAllCenters, getDuplicatePatients, mergePatient } from "../../../../core/services/api"
import ViewPatient from "../../../CenterAdmin/ViewPatient/ViewPatient"
import "./MergePatients.scss"
import PrintMergePatients from "./PrintMergePatients"
// import Button from "react-bootstrap/esm/Button"
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked'
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked'
import { IconButton } from "@mui/material"
import { MocUserRole } from "core/services/models/Enums"
import { useSelector } from "react-redux"
import Select from "react-select"

function MergePatients() {
  const history = useHistory()
  const [data, setData] = useState<any>()
  const [upDatedData, setUpDatedData] = useState<any>()
  const [test, setTest] = useState<any>()
  const [displayToast, toggleDisplayToast] = useState<any>()
  const [viewPatient, setViewPatient] = useState(false)
  const [id, setId] = useState<any>()
  const componentRef: any = useRef<any>(null);
  const [ismerge, setIsMerge] = useState<any>()
  const [centerOptions, setCenterOptions] = useState<any>([])
  const [centerFilter, setCenterFilter] = useState<any>("")
  const [centerName, setCenterName] = useState<any>("")
  const [isResetting, setIsResetting] = useState(false)
  // @ts-ignore
  let readOnly = useSelector((state) => state?.user?.readOnly);
  const userRole = useSelector((state: any) => state?.user?.role)
  const userDetail = useSelector((state: any) => state?.user?.userDetail)

  //Search Text
  const [searchText, setSearchText] = useState<any>("")



  //Pagination
  const [pages, setPages] = useState<any>(0)
  const [currPage, setCurrPage] = useState<any>(0)
  const [pageSize, setPageSize] = useState<any>(10)
  const [totalPatientsCount, setTotalPatientsCount] = useState<any>("")

  useEffect(() => {
    getAllCenters()
      .then((res: any) => {
        const tempCenters: any = res?.map((each: any) => {
          return { label: each?.centerName, value: each?.id }
        })
        setCenterOptions(tempCenters)
      })
      .catch((err: any) => console.log(err?.message))
  }, [])

  useEffect(() => {
    fetchDuplicatePatients()
  }, [centerFilter, pageSize, currPage, searchText, centerName])

  function fetchDuplicatePatients() {
    let url = "/duplicates";
    if ((userRole === MocUserRole.SYSTEM_ADMIN || userRole === MocUserRole.OPERATIONS) && centerFilter) {
      url += `?centerName=${centerName}&page=${currPage}&pageSize=${pageSize}`;
    } else if (userRole === MocUserRole.CENTER_ADMIN) {
      const centerId = userDetail?.currentCenter?.centerId;
      const centerName = userDetail?.currentCenter?.centerName;
      url += `?centerName=${centerName}&page=${currPage}&pageSize=${pageSize}`;
    } else {
      url += `?page=${currPage}&pageSize=${pageSize}`;
    }

    if (searchText) {
      // You may want to properly encode searchText to ensure it doesn't contain special characters that could interfere with the URL
      url += `&searchText=${searchText}`;
    }

    getDuplicatePatients(url)
      .then((res) => {
        const temp = { ...res?.data }
        setData(Object.assign({}, res?.data))
        const { data, totalPages, totalElements, duplicateCount } = res
        setUpDatedData(temp)
        setTest(res.data)
        console.log(temp, "temp");
        console.log(duplicateCount, "duplicate count");
        setPages(Math.floor(duplicateCount / pageSize) + 1);
      })
      .catch((err) => {
        console.log("err", err)
      })
  }

  const handleViewPatient = (id: any, eachpat: any) => {
    setViewPatient(true)
    setId(id)
  }

  const handleReset = () => {
    setIsResetting(true)
    try {
      // Create a deep copy of the data object
      const resetData = JSON.parse(JSON.stringify(data))
      // Reset any modifications in the data
      Object.keys(resetData).forEach(key => {
        resetData[key].forEach((patient: any) => {
          delete patient.notDuplicate
          delete patient.toRetain
        })
      })
      setUpDatedData(resetData)
    } catch (error) {
      console.log('error reseting')
    } finally {
      setIsResetting(false)
    }
  }

  const handleMergePatient = () => {
    const objToArray = Object.entries({ ...upDatedData });
    console.log(objToArray, "objToArray");
    const json: any = [];

    Object.keys(upDatedData)?.map((eachPhNo) => {
      const phNoData = [...upDatedData[eachPhNo]];
      console.log("ph", phNoData);

      let findND = phNoData?.filter((each) => each?.notDuplicate);
      let findToRet = phNoData?.find((each) => each?.toRetain);
      console.log(findToRet, "findToRet");

      if (findToRet) {
        let filteredData = phNoData?.filter((each) => !each?.notDuplicate && !each?.toRetain);
        console.log("filteredData", filteredData);

        if (filteredData?.length > 0) {
          filteredData?.map((eachFD) => {
            console.log(eachFD, "eachFD");
            json.push({ from: eachFD?.id, to: findToRet?.id, notDuplicate: [] });
          });
        }
      }

      if (findND?.length > 0) {
        const ids = findND?.map((each) => each?.id);

        if (findToRet?.id === findND[0]?.id) {
          console.log(findToRet?.id, "findToRet?.id1");
          json.push({ from: findND[0]?.id, to: findToRet?.id, notDuplicate: [] });

        } else {
          console.log(findToRet?.id, "findToRet?.id");
          json.push({ from: findND[0]?.id, to: findToRet?.id, notDuplicate: [] });
        }

        console.log(ids, "ids");
      } else if (findToRet) {
        // Check if toRetain ID is equal to notDuplicate ID
        if (findToRet?.id === findToRet?.notDuplicate) {
          json.push({ from: findToRet?.id, to: null, notDuplicate: [] });
        } else {
          const notDuplicate = findToRet?.notDuplicate ? [findToRet?.notDuplicate] : [];
          json.push({ from: findToRet?.id, to: null, notDuplicate });
        }
      }
    });

    mergePatient(json)
      .then((mergeResponse) => {
        console.log("mergeResponse", mergeResponse);
        setIsMerge(mergeResponse);
        toggleDisplayToast({
          text: "Merged the patients successfully",
          type: "success",
        });
        fetchDuplicatePatients();
      })
      .catch((err) => {
        toggleDisplayToast({
          text: "Please enter correct details",
          type: "error",
        });
      });
  };

  return (
    <div className="merge-patient-container">
      <div className="merge-patient-heading">
        <div
          className="approval-back-image"
          onClick={() => {
            history.push("/home")
          }}
        >
          <img
            src={"../../../assets/images/back-icon.svg"}
            height={"60px"}
            width={"60px"}
            alt="back button"
            className="back_button"

          />
        </div>
        <div className="merge-patient-text">Merge Patient</div>
      </div>
      <PrintMergePatients printRef={componentRef} upDatedData={upDatedData} />
      {
        (userRole === MocUserRole.SYSTEM_ADMIN || userRole === MocUserRole.OPERATIONS) && (
          <div
            className="col-md-3 col-lg-3 mt-2"
            style={{ marginLeft: "25px" }}
          >
            <div>
              <label className="location-label">Location : </label>
            </div>
            <Select
              styles={{
                control: (provided, state) => ({
                  ...provided,
                  border: "1px solid #ccd0e7",
                  borderRadius: "10px"
                })
              }}
              options={centerOptions}
              onChange={(option: any) => {
                console.log(option, "options");
                setCenterFilter(option?.value)
                setCenterName(option?.label);
              }}
              placeholder="Select Location..."
              value={centerOptions?.filter(({ value }: any) => value === centerFilter)}
            />
          </div>
        )
      }
      <div style={{ marginLeft: '2%', marginTop: '2%' }}>
        <div className="search-dropdown-wrapper">
          <div className="row pl-42 pt-17px">
            <div className="col-md-6 col-lg-6">
              <span>
                <input
                  className="inputGlobalSearch"
                  placeholder="Search"
                  onChange={(e) => {
                    //handleSearch(e.target.value)
                    //setSearchText(e.target.value)
                    setSearchText(e.target.value)
                    setCurrPage(0)

                  }}
                />
                <img
                  src="assets/images/searchIcon.svg"
                  alt=""
                  style={{
                    marginLeft: "-50px",
                    width: "26px",
                    height: "26px",
                  }}
                />
              </span>
            </div>

          </div>
        </div>
      </div>
      <div className="merge-patient-container">
        <div className="row heading-section">
          <div className="col-4 name-heading"></div>
          <div className="col-2 moc_Id">Moc Id</div>
          <div className="col-2 toggle-heading">Mark as duplicate</div>
          <div className="col-1 retain-heading">Merge</div>
        </div>
        <div>
          {upDatedData &&
            Object.keys(upDatedData)?.length > 0 &&
            Object.keys(upDatedData)?.map((eachKey: any) => (
              <div className="value-section">
                <div className="phone-number-section">Name : {eachKey}</div>
                <div className="duplicate-count-section">
                  Center Name : {
                    upDatedData[eachKey]?.length > 0 ? upDatedData[eachKey][0]?.centerName : ""
                  }
                </div>
                <div className="duplicate-count-section">
                  Duplicate Count:&nbsp;{upDatedData[eachKey].length}
                </div>
                {upDatedData[eachKey]?.map((eachPat: any, index: any) => (
                  <div>
                    <div className="row patient-details">
                      <div className="col-4">
                        <p
                          className="patient-name-section"
                          // onClick={() => setViewPatient(true)}
                          onClick={() =>
                            handleViewPatient(eachPat?.id, eachPat)
                          }
                        >
                          {eachPat?.name}
                        </p>
                        <div>
                          {viewPatient === true && <ViewPatient id={id} />}
                        </div>
                      </div>
                      <div className="col-2">
                        <span className="mocidtext">{eachPat?.mocId}</span>
                      </div>

                      <div className="col-2">
                        <ToggleSwitch
                          disabled={eachPat?.toRetain || readOnly}
                          checked={eachPat?.notDuplicate}
                          onChange={(e: any) => {
                            let temp = { ...upDatedData }
                            if (temp[eachKey] && temp[eachKey][index]) {
                              let tempPat = [...temp[eachKey]]
                              tempPat[index]["notDuplicate"] = e.target.checked
                              temp[eachKey] = tempPat
                              setUpDatedData(temp)
                            }
                          }}
                        />
                      </div>
                      <div className="col-1 radio-section ">
                        <div onClick={() => {
                          if (readOnly) return null
                          let temp = { ...upDatedData }
                          if (temp[eachKey] && temp[eachKey][index]) {
                            let tempPat = [...temp[eachKey]]

                            tempPat[index]["toRetain"] = !eachPat.toRetain
                            if (eachPat.toRetain) {
                              tempPat[index]["notDuplicate"] = false
                            }
                            temp[eachKey] = tempPat
                            setUpDatedData(temp)
                          }
                        }}>
                          {eachPat?.toRetain ?
                            <IconButton>
                              <RadioButtonCheckedIcon style={{ width: "50%", height: "100%", color: "#2196F3" }} />
                            </IconButton>
                            :
                            <IconButton>
                              <RadioButtonUncheckedIcon style={{ width: "50%", height: "100%", }} />
                            </IconButton>}


                        </div>

                        {/* <input
                          type="radio"
                          name={eachKey}
                          id="myRadio-2"
                          value={eachPat?.toRetain}
                          width="30px"
                          onChange={(e: any) => {
                            let temp = { ...upDatedData }
                            if (temp[eachKey] && temp[eachKey][index]) {
                              let tempPat = [...temp[eachKey]]
                              tempPat[index]["toRetain"] = e.target.checked
                              if (e.target.checked) {
                                tempPat[index]["notDuplicate"] = false
                              }
                              temp[eachKey] = tempPat
                              setUpDatedData(temp)
                            }
                          }}
                        /> */}

                      </div>
                    </div>
                  </div>
                ))}
              </div>

            ))}
        </div>
        {/* Pagination */}


        {
          data && Object.keys(data).length > 0 ? (
            <div
              style={{ marginTop: "20px" }} className="pagination-footer"
            >
              <button
                className="pagination-button"
                onClick={() => {
                  setCurrPage(0);
                }}
                disabled={currPage === 0}
              >
                {"First"}
              </button>
              <button
                className="pagination-button"
                onClick={() => {
                  setCurrPage(currPage - 1);
                }}
                disabled={currPage === 0}
              >
                {"Previous"}
              </button>
              <span className="pagination-text">
                Page{" "}
                <strong>
                  {currPage + 1} of {pages}
                </strong>
              </span>
              <button
                className="pagination-button"
                onClick={() => {
                  setCurrPage(currPage + 1);
                }}
                disabled={currPage === pages - 1}
              >
                {"Next"}
              </button>
              <button
                className="pagination-button"
                onClick={() => {
                  setCurrPage(pages - 1);
                }}
                disabled={currPage === pages - 1}
              >
                {"Last"}
              </button>
              <select
                className="pagination-select"
                value={pageSize}
                onChange={(e) => {
                  setPageSize(Number(e.target.value));
                  setCurrPage(0);
                }}
              >
                {[10, 15, 20, 25, 50].map((pageSize) => (
                  <option key={pageSize} value={pageSize}>
                    {pageSize}
                  </option>
                ))}
              </select>
            </div>
          ) : null
        }
      </div>
      <div className="reset-container">
        {/* <Button text="reset" onClick={() => setUpDatedData(data)} />
         */}
        <div>
          <Button
            text="Merge Patient"
            outline={true}
            disabled={readOnly}
            onClick={() => handleMergePatient()}
          />

        </div>
        <div style={{ marginLeft: "5px" }}>
          <Button text="reset" disabled={readOnly || !upDatedData} onClick={() => handleReset()} />

        </div>

        <div>

          {viewPatient === true && (
            <ViewPatient closePrintModal={setViewPatient} id={id} />
          )}
        </div>
        {displayToast && (
          <div className="Toast_aligner">
            <Toast
              className="Toast_aligner"
              textMessage={displayToast?.text}
              onClose={() => {
                toggleDisplayToast(false)
                if (displayToast?.type === "success") {
                  history.push('/mergePatients')
                }
              }}
              onCloseText="Close"
              onClickText={
                displayToast?.onClickText ? displayToast?.onClickText : null
              }
              onClick={() => (displayToast?.onClickText ? history.goBack() : null)}
              type={displayToast?.type}
            />
          </div>
        )}

      </div>
    </div>
  )
}
export default MergePatients
